<div *ngIf="formVariant" [formGroup]="formVariant">
  <mat-form-field class="form-field-fixed-m margin-input space-h-l space-t-l" appearance="fill">
    <span matPrefix><span class="far fa-clock times-pre-icon times-center"></span></span>
    <mat-label>{{ 'FACETS.TOTALTIME.TITLE' | translate }}</mat-label>
    <input
      matInput
      type="text"
      [mask]="timeMask"
      [patterns]="timePatterns"
      [specialCharacters]="specialCharacters"
      [keepCharacterPositions]="true"
      [(ngModel)]="durations.totalTime"
      id="RecipesModifyStepsTimeTotalTxt"
      [ngModelOptions]="{ standalone: true }"
      class="times-center"
      disabled="true"
    />
    <button
      matSuffix
      mat-raised-button
      class="btn times-btn"
      [matMenuTriggerFor]="totalTimeMenu"
      *ngIf="durations.applianceGroupDurations?.length"
    >
      <span class="fa fa-plus"></span>
    </button>
    <mat-menu #totalTimeMenu="matMenu" yPosition="below">
      <button class="menu-time-btn" mat-menu-item *ngFor="let applianceGroupDurations of durations.applianceGroupDurations">
        {{ applianceText(applianceGroupDurations.applianceGroup) }}
        <span *ngIf="applianceGroupDurations.applianceGroup === formVariant.controls.defaultApplianceGroup.value"
          >({{ 'DEFAULT' | translate }})</span
        >
        <span class="menu-time">{{ convertMinToHoursMin('' + applianceGroupDurations.totalTime) }}</span>
      </button>
    </mat-menu>
  </mat-form-field>

  <mat-form-field class="form-field-fixed-m margin-input space-h-l space-t-l" appearance="fill">
    <img matPrefix alt="preparation" class="times-icon" src="assets/images/preparation.svg" />
    <mat-label>{{ 'PREPTIME' | translate }}</mat-label>
    <input
      matInput
      type="text"
      #PrepTime
      [mask]="timeMask"
      [patterns]="timePatterns"
      [specialCharacters]="specialCharacters"
      [keepCharacterPositions]="true"
      [(ngModel)]="durations.prepTime"
      [ngModelOptions]="{ standalone: true }"
      (change)="changeTime(PrepTime, 'prepTime')"
    />
  </mat-form-field>

  <mat-form-field class="form-field-fixed-m margin-input space-h-l space-t-l" appearance="fill">
    <img matPrefix alt="cooking" class="times-icon" src="assets/images/cuisson.svg" />
    <mat-label>{{ 'COOKTIME' | translate }}</mat-label>
    <input
      matInput
      type="text"
      #CookTime
      [mask]="timeMask"
      [patterns]="timePatterns"
      [specialCharacters]="specialCharacters"
      [keepCharacterPositions]="true"
      id="RecipesModifyStepsTimeCookTxt"
      [(ngModel)]="durations.cookingTime"
      [ngModelOptions]="{ standalone: true }"
      (change)="changeTime(CookTime, 'cookingTime')"
    />
    <button
      matSuffix
      mat-raised-button
      class="btn times-btn"
      [matMenuTriggerFor]="cookingTimeMenu"
      *ngIf="durations.applianceGroupDurations?.length"
    >
      <span class="fa fa-plus"></span>
    </button>
    <mat-menu #cookingTimeMenu="matMenu" yPosition="below">
      <button class="menu-time-btn" mat-menu-item *ngFor="let applianceGroupDurations of durations.applianceGroupDurations">
        {{ applianceText(applianceGroupDurations.applianceGroup) }}
        <span *ngIf="applianceGroupDurations.applianceGroup === formVariant.controls.defaultApplianceGroup.value"
          >({{ 'DEFAULT' | translate }})</span
        >
        <span class="menu-time">{{ convertMinToHoursMin('' + applianceGroupDurations.cookingTime) }}</span>
      </button>
    </mat-menu>
  </mat-form-field>

  <mat-form-field class="form-field-fixed-m margin-input space-h-l space-t-l" appearance="fill">
    <img matPrefix alt="cooking" class="times-icon" src="assets/images/cuisson.svg" />
    <mat-label>{{ 'OFF_APPLIANCE_COOKTIME' | translate }}</mat-label>
    <input
      matInput
      type="text"
      id="RecipesModifyStepsTimeCookOutTxt"
      #OffApplianceCookingTime
      [mask]="timeMask"
      [patterns]="timePatterns"
      [specialCharacters]="specialCharacters"
      [keepCharacterPositions]="true"
      [(ngModel)]="durations.offApplianceCookingTime"
      [ngModelOptions]="{ standalone: true }"
      (change)="changeTime(OffApplianceCookingTime, 'offApplianceCookingTime')"
    />
  </mat-form-field>

  <mat-form-field class="form-field-fixed-m margin-input space-h-l space-t-l" appearance="fill">
    <img matPrefix alt="rest" class="times-icon" src="assets/images/repos.svg" />
    <mat-label>{{ 'RESTTIME' | translate }}</mat-label>
    <input
      matInput
      type="text"
      id="RecipesModifyStepsTimeRestTxt"
      #RestingTime
      [mask]="timeMask"
      [patterns]="timePatterns"
      [specialCharacters]="specialCharacters"
      [keepCharacterPositions]="true"
      [(ngModel)]="durations.restingTime"
      [ngModelOptions]="{ standalone: true }"
      (change)="changeTime(RestingTime, 'restingTime')"
    />
  </mat-form-field>
</div>
